import {QuestConfig, Token, QuestsApi, GetQuestConfigsForUserRequest } from "@devour/client";
import getConfig from "@/utils/getConfig";
import { useQuery } from "@tanstack/react-query";

async function fetchQuestConfigsForUser(fullToken: Token, query: GetQuestConfigsForUserRequest): Promise<Array<QuestConfig>> {
    return await new QuestsApi(getConfig(fullToken)).getQuestConfigsForUser(query);
}

function getQuestConfigsForUserQuery(fullToken: Token, query: GetQuestConfigsForUserRequest) {
    return {
        queryKey: [
            "quest-configs-user",
            fullToken?.id ?? "unauthenticated",
            query,
        ],
        queryFn: () => fetchQuestConfigsForUser(fullToken, query),
        keepPreviousData: true,
        staleTime: 30 * 24 * 60 * 60000,
        refetchOnWindowFocus: false,
        enabled: Boolean(query.gameId || query.challenges || query.guildId),
    } as const;
}

export function useGetQuestConfigsForUser(fullToken: Token, query: GetQuestConfigsForUserRequest) {
    return useQuery(getQuestConfigsForUserQuery(fullToken, query));
}